<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UhZdi2/tc-custom/9781467462501.jpg?1728851905605" alt="This image is the cover for the book Good Works"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good Works
      </h1>
      <p class="bookDescription body article font2">
        <p>For over forty years, the community of Good Works, Inc., has shared life with its neighbors in rural southeastern Ohio, a region with high poverty rates and remarkably resilient people. Offering friendship to those without a support network and shelter, care, and community to people without homes, those involved with Good Works have made it their mission to embody the gospel in innovative ways. What insights can be gleaned from Good Works, and how might these lessons be applied to our own communities and churches? </p><p>Keith Wasserman, the founder and executive director of Good Works, and Christine Pohl, a scholar of hospitality who has written extensively on church and mission, explore challenging insights from the story of Good Works and how it has grown over the years into a unique expression of discipleship in the body of Christ. At the heart of this community’s story are connection and mutuality. Good Works functions not as a charity or social service agency but as a place where everyone has the opportunity to both serve and be served. And although worship is a central paradigm for life at Good Works, Keith and the leaders of the community regularly partner with non-Christians from all walks of life who desire to help. </p><p>Christians who hunger for lifegiving involvement in their local communities—wherever they might be, and in whichever circumstances—will find inspiration and guidance in this quiet but powerful Appalachian ministry. Short prayers and questions for reflection at the end of each chapter make this a book to be studied and shared among those who know that love of God and neighbor is the starting point, but who aren’t sure where to go from there.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Keith Wasserman, Christine D. Pohl
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Keith Wasserman</B>&#160;is founder and executive director of Good Works, Inc., a nonprofit ministry that, for more than forty years, has worked alongside people in rural Appalachia to build a community of hope among those struggling with poverty, isolation, exclusion, and homelessness.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?635c28a6